
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/success",
      function () {
        return require("private-next-pages/signup/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/success"])
      });
    }
  